import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Dollar = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M7.999 16h-2c0 .038.063 3.538 5 3.957v2.031h2V19.96c4.319-.34 5-2.894 5-4.46 0-1.264-.514-4.094-5-4.459V6.088c1.845.346 1.991 1.636 2 1.926l1-.014h1c0-1.258-.871-3.528-4-3.932V2h-2v2.041c-4.486.365-5 3.195-5 4.459 0 1.566.681 4.12 5 4.46v4.987c-2.821-.29-2.991-1.78-3-1.947zm8-.5c0 .62-.011 2.169-3 2.451v-4.9c2.989.291 3 1.888 3 2.449zm-8-7c0-.561.011-2.158 3-2.45v4.901c-2.989-.282-3-1.831-3-2.451z", key: "k0" })));
});
Dollar.displayName = 'Dollar';
export var DollarDimensions = { height: 24, width: 24 };
